import * as yup from 'yup';

export const creditCardSchema = yup.object({
  card_number: yup
    .string()
    .matches(/^\d+(\s*\d+)*\s*$/, 'Card Number should be valid')
    .required('Card Number is required'),
  card_cvv2: yup
    .string()
    .matches(/^\d+$/, 'Code must only contain numbers')
    .min(3, 'Code must be 3 or 4 digits')
    .max(4, 'Code must be 3 or 4 digits')
    .required('Code is required'),
  exp_month: yup.string().required('Expiration Month is required'),
  exp_year: yup.string().required('Expiration Year is required'),
  owner: yup.string().required("Persons's Name is required"),
  addr_ln1: yup.string().required('Billing Address is required'),
  city: yup.string().required('City is required'),
  state: yup.string().required('State is required'),
  zip: yup
    .string()
    .matches(/^\d+$/, 'Zip Code must only contain numbers')
    .required('Zip Code is required')
});

export const updateCreditCardSchema = yup.object({
  exp_month: yup.string(),
  exp_year: yup.string(),
  allow_purchases: yup.string(),
  allow_billing: yup.string()
});
